import { createRoot } from 'react-dom/client';
import '@tabler/core/dist/js/tabler.min.js';
import '@xyflow/react/dist/base.css';
import './graph/canvas/theme.css';
import { EditorShell } from './graph/shell/EditorShell';
import { initThemeToggle } from './graph/shell/themeToggle';
import { settingsNav } from './graph/store/settingsNav';
import { initializeCheckpointClient } from './checkpointHelper/static/globalAuth';
import { ClientHandler } from './checkpoint';
import { app } from './checkpointHelper/app';
import { setCheckpointHandler } from './checkpointHelper/static/auth-session';
import type { BrainMember, CheckpointAuthUser } from './checkpointHelper/static/auth-types';
import type { SecondaryUser } from './checkpoint/secondary-users';
import { CHECKPOINT_APPS } from './checkpoint/app-names';
import { checkpoint } from './checkpointHelper/app';
import { initSettingsData } from './settings/state';
import { updateUserAccountNav } from './auth-display';
import type { ClientUserType } from './checkpoint/client-handler';
initThemeToggle();

// The "Settings" link lives in the static Blade header (outside the React
// root), so it can't just be a React onClick — bridge it into the app via
// the settingsNav store (same pattern tilemapNav.ts uses for tilemap_ref
// nodes), which EditorShell subscribes to.
document.getElementById('settingsLink')?.addEventListener('click', (e) => {
    e.preventDefault();
    settingsNav.getState().show();
});


async function run(){
    const handler = new ClientHandler(checkpoint, '/');
    setCheckpointHandler(handler);

    const result = await handler.handlePageLoad();

    if (!result.authState.isAuthenticated) {
        window.location.href = handler.buildLoginUrl('normal', CHECKPOINT_APPS.GRAPH_EDITOR);
        throw new Error('Dream Graph requires an authenticated Checkpoint session');
    }

    const authUser = result.authState.user as CheckpointAuthUser | null;
    const authMember = result.authState.member as BrainMember | null;

    if (!authUser || !authMember) {
        await handler.logout();
        window.location.href = handler.buildLoginUrl('normal', CHECKPOINT_APPS.GRAPH_EDITOR);
        throw new Error('Checkpoint session is missing required user or member');
    }

    app.window.user = authUser;
    app.window.member = authMember;
    app.window.userType = result.authState.userType as ClientUserType;

    await initSettingsData();
    updateUserAccountNav();
}



run();

const rootEl = document.getElementById('graph-editor-root');
if (rootEl) {
    createRoot(rootEl).render(<EditorShell />);
}
